import type { GlucoseHighsAndLowsInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./HighsAndLows.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { usePolyglot } from "src/contexts"

const size = 48
const strokeWidth = 2.4
// const offset = strokeWidth / 2
const radius = (size - strokeWidth) / 2
const centerX = size / 2
const centerY = size / 2

export function GlucoseHighsAndLows(props: TileProps<GlucoseHighsAndLowsInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { glucoseCalculations } = useCalculationsContext()
  const {
    highs,
    lows,
  } = glucoseCalculations[range] || {}

  const viewBox = `0 0 ${size} ${size}`
  const highsString = highs === undefined || isNaN(highs) ? "--" : highs.toLocaleString(polyglot.locale())
  const lowsString = lows === undefined || isNaN(lows) ? "--" : lows.toLocaleString(polyglot.locale())

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <div className={styles.highsAndLows}>
        <svg
          className={styles.highsAndLowsCircle}
          viewBox={viewBox}
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx={centerX}
            cy={centerY}
            r={radius}
          />
        </svg>
        <div
          className={styles.highsAndLowsValues}
          id={`${insightKey}-value`}
        >
          {highsString}
          <div className={styles.highsAndLowsValueSeparator} />
          {lowsString}
        </div>
      </div>
    </>
  )
}
